import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import AInputAutocomplete from '@/components/atoms/AInputAutocomplete.vue'

	import { reactive } from 'vue'
	import { useInput } from '@/hooks'

	
export default /*#__PURE__*/_defineComponent({
  props: {
		modelValue: { type: [String, Object, Array] },
		keyName: { type: String, default: '' },
		id: { type: String, default: '' },
		label: { type: String, default: '' },
		hint: { type: String, default: '' },
		placeholder: { type: String, default: '' },
		prefix: { type: String, default: '' },
		suffix: { type: String, default: '' },
		prependIcon: { type: String, default: '' },
		appendIcon: { type: String, default: '' },
		itemText: { type: String, default: '' },
		itemValue: { type: String, default: 'value' },
		minLength: { type: Number, default: null },
		maxLength: { type: Number, default: null },
		required: { type: Boolean, default: false },
		loading: { type: Boolean, default: false },
		disabled: { type: Boolean, default: false },
		multiple: { type: Boolean, default: false },
		returnObject: { type: Boolean, default: false },
		cellEditor: { type: Boolean, default: false },
		items: { type: Array, default: () => [] },
		allowedIds: { type: Array, default: () => [] },
		customerIds: { type: Array, default: () => [] }
	},
  emits: ['update:modelValue', 'input', 'change', 'blur', 'clear'],
  setup(__props, { emit: $emit }) {

const $props = __props

	
	

	const state = reactive({
		loading: false,
		item: undefined,
		items: [],
		storeModule: 'persons',
		itemText: 'person_name',
		itemValue: 'person_id',
		icon: 'person',
		label: {
			default: 'General_person',
			multiple: 'General_persons'
		}
	})

	const { label, icon, init } = useInput($props, state)

	init(true)

	function onUpdateValue(val?: any) {
		const value = val || state.item
		$emit('update:modelValue', value)
	}
	function onInput(val: any) {
		onUpdateValue()
		$emit('input', val)
	}
	function onChange(val: any) {
		onUpdateValue(val)
		$emit('change', val)
	}
	function onBlur(val: any) {
		onUpdateValue()
		$emit('blur', val)
	}
	function onClear() {
		$emit('clear')
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AInputAutocomplete, {
    label: _unref(label),
    modelValue: _unref(state).item,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).item) = $event)),
      _cache[1] || (_cache[1] = ($event: any) => (onUpdateValue($event)))
    ],
    items: _unref(state).items,
    "item-text": _unref(state).itemText,
    "item-value": _unref(state).itemValue,
    loading: _unref(state).loading,
    icon: _unref(icon),
    hint: $props.hint,
    multiple: $props.multiple,
    required: $props.required,
    disabled: $props.disabled,
    "return-object": $props.returnObject,
    "cell-editor": $props.cellEditor,
    onInput: _cache[2] || (_cache[2] = ($event: any) => (onInput($event))),
    onChange: _cache[3] || (_cache[3] = ($event: any) => (onChange($event))),
    onBlur: _cache[4] || (_cache[4] = ($event: any) => (onBlur($event))),
    onClear: _cache[5] || (_cache[5] = ($event: any) => (onClear()))
  }, null, 8, ["label", "modelValue", "items", "item-text", "item-value", "loading", "icon", "hint", "multiple", "required", "disabled", "return-object", "cell-editor"]))
}
}

})